import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { signupCookie } from '@/utils/cookies/signupCookie';

export default function SignupPopupSuccess({ changeStatu, isRegistered }: any) {
    const { useLang, isMobile, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('shared.signup_popup.success');
    const SIGNUP_POPUP_SITES: string[] = ['au', 'kr', 'jp', 'eu', 'uk', 'de', 'fr', 'it', 'es', 'us', 'ca', 'za'];

    const handleClick = () => {
        changeStatu(0);
        signupCookie({ entry_name: 'subscription floating' });
        return true;
    };

    return (
        <div className={`signup-popup-success ${css['signup-popup-success']} ${isMobile ? 'signup-popup-success-h5' : 'signup-popup-success-pc'}`}>
            <div className={`popup-content ${!isRegistered ? 'full' : 'single'}`}>
                <span className="close" onClick={() => changeStatu(0)}>
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g opacity="0.4">
                            <path
                                fillRule="evenodd"
                                clipRule="evenodd"
                                d="M12 2.80005C14.5403 2.80005 16.8403 3.82993 18.5052 5.49486C20.1702 7.15979 21.2001 9.45978 21.2001 12C21.2001 14.5403 20.1702 16.8403 18.5052 18.5052C16.8403 20.1702 14.5403 21.2001 12 21.2001C9.45978 21.2001 7.15979 20.1702 5.49486 18.5052C3.82993 16.8403 2.80005 14.5403 2.80005 12C2.80005 9.45978 3.82993 7.15979 5.49486 5.49486C7.15979 3.82993 9.45978 2.80005 12 2.80005Z"
                                stroke="black"
                                strokeWidth="1.6"
                            />
                            <path d="M8.5 8.5L15.5 15.5M15.5 8.5L8.5 15.5" stroke="black" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </g>
                    </svg>
                </span>
                {!isRegistered && (
                    <>
                        <div className="img-box">
                            <NextImage src={require(`@publicLocal/signup-popup/${isMobile ? 'h5' : 'pc'}/2_2.png`)} alt={t('title')} aria-label={t('title')} />
                        </div>
                        <p className="title">{t('title')}</p>
                        <p className="desc">
                            {t.rich('desc', {
                                s: (text: string) => <span className="s">{text}</span>,
                            })}
                        </p>
                        <>
                            <p className="card-title">{t('card_title')}</p>
                            <Link onClick={handleClick} className="card-btn" href="/register">
                                {t('card_btn')}
                            </Link>
                            <p className="tip">{t('tip')}</p>
                        </>
                    </>
                )}
                {isRegistered && (
                    <div className="full-img">
                        <NextImage src={require(`@publicLocal/signup-popup/${isMobile ? 'h5' : 'pc'}/2_11.png`)} alt={t('title')} aria-label={t('title')} />
                        <div className="info">
                            <p className="title">{t('title')}</p>
                            {!['jp', 'kr', 'za'].includes(locale) && (
                                <p className="desc">
                                    {t('desc_unRigisted') ||
                                        t.rich('desc', {
                                            s: (text: string) => <span className="s">{text}</span>,
                                        })}
                                </p>
                            )}
                            {locale === 'za' && (
                                <p className="desc">
                                    {t.rich('desc_registered', {
                                        s: (text: string) => <span className="s">{text}</span>,
                                    })}
                                </p>
                            )}
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
